import type { PropertyFilters } from '~/core/entities/property/filters';

import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';

export function getCleanStaticListingPath(
	filters: Partial<PropertyFilters>
): string {
	return PropertyFiltersPresenter.getPathFromFilters(filters).split('?')[0]!;
}
